import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { isNew } from "@/components/ArticleCard";

export const NewArticleBanner = ({ articles }) => {
  const { lang } = useLang();
  const a = articles.find((x) => x.category === "Curiosity" && isNew(x));
  if (!a) return null;
  return (
    <Link to={`/article/${a.slug}`} data-testid="new-article-banner"
      className="group block bg-[#E63946] text-white hover:bg-[#D90429] transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center gap-3 text-sm">
        <span className="inline-flex items-center gap-1.5 shrink-0 bg-white text-black text-[10px] font-mono font-bold uppercase tracking-widest px-2 py-0.5 rounded">
          <Sparkles size={11} /> {lang === "it" ? "Nuovo" : "New"}
        </span>
        <span className="truncate font-semibold">{a.title}</span>
        <ArrowRight size={15} className="shrink-0 ml-auto group-hover:translate-x-1 transition-transform" />
      </div>
    </Link>
  );
};
